/**
 * The list tables' compact columns (#952 H7, U8). They switch on the list's OWN width, not the
 * shell's: the table's wrapper is the `list` container, and its cells query it. With the rail
 * open, a 1180 px window leaves the list ≈ 916 px, which must already be the compact table.
 */
export const LIST_CONTAINER = '@container/list';

/**
 * A column or line shown only from 1180 px of list width. Tailwind's `@max-[N]` is `width < N`, so
 * 1180 here and in `COMPACT_ONLY` split the widths with no pixel where both or neither show.
 */
export const WIDE_ONLY = '@max-[1180px]/list:hidden';

/** A line shown only below 1180 px of list width, where the wide columns fold into it. */
export const COMPACT_ONLY = '@min-[1180px]/list:hidden';
